/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_DocsInputs */

const en_mk_nav_docs = /** @type {(inputs: Mk_Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

const id_mk_nav_docs = /** @type {(inputs: Mk_Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentasi`)
};

/**
* | output |
* | --- |
* | "Docs" |
*
* @param {Mk_Nav_DocsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_docs = /** @type {((inputs?: Mk_Nav_DocsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_DocsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_docs(inputs)
	return en_mk_nav_docs(inputs)
});